import React from 'react';
import AvailableComponentLists from '../../utils/AvailableComponentLists';
import { selectedToggleValue, toggleMobile } from '../../redux/canvasResolutionSlice';
import { useDispatch, useSelector } from 'react-redux';

import ErrorBoundary from '../canvas/Error/ErrorBoundary';
import SelectableCssVariablesImport from '../canvas/SelectableCssVariables/SelectableCssVariablesImport';
import _ from 'lodash';

const VtexStoreComponent = ({ componentName, props, children, blocks, wrapper, componentId }) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	if (!componentName) {
		return console.error(`Componente nao encontrado`);
	} else {
		return AvailableComponentLists(
			componentName,
			props,
			children,
			blocks,
			selectedCanvasResolution,
			wrapper,
			componentId,
		);
	}
};

const VtexJsonUploadComponentWM = ({ comp, componentId, componentGroup, dontAddHover = false }) => {
	const [compProps, setCompProps] = React.useState(comp);
	const resize = _.debounce(handleResize, 250);
	const dispatch = useDispatch();

	function handleResize() {
		const w = document.body.clientWidth;
		if (w > 1024) return dispatch(toggleMobile(1920));
		if (w > 640) return dispatch(toggleMobile(1024));
		if (w <= 640) return dispatch(toggleMobile(467));
	}

	React.useEffect(() => {
		window.addEventListener('resize', resize);
		return () => window.removeEventListener('resize', resize);
	}, []);

	if (
		!compProps ||
		!compProps.componentName ||
		(compProps.componentName == 'VisibilityLayout' && !compProps.props.visible)
	) {
		return null;
	}

	return (
		<ErrorBoundary>
			{compProps?.variables && <SelectableCssVariablesImport component={compProps} variables={compProps.variables} />}
			{/* {!dontAddHover && !compProps?.props?.mzDontAddHover?<div data-hover={componentId} data-componentname={compProps?.componentName ?? "No Name"} style={{display:"none"}}></div>:null} */}
			<VtexStoreComponent
				{...compProps}
				blocks={
					compProps.blocks &&
					compProps.blocks.map((block) => (
						<VtexJsonUploadComponent
							key={'VVC-' + block.componentId}
							{...{
								componentId: block.componentId,
								comp: block,
								componentGroup: block?.componentGroup || componentGroup,
							}}
						/>
					))
				}
			>
				{((compProps && compProps.childrenComponents) || []).map((childComp) => {
					return (
						<VtexJsonUploadComponent
							key={`vtex-visualization-component-${childComp.componentId}`}
							{...{
								componentId: childComp.componentId,
								comp: childComp,
								componentGroup: childComp?.componentGroup || componentGroup,
							}}
						/>
					);
				})}
			</VtexStoreComponent>
		</ErrorBoundary>
	);
};
const VtexJsonUploadComponent = React.memo(VtexJsonUploadComponentWM);
export default VtexJsonUploadComponent;
